import { defineComponent, onMounted, reactive, toRefs } from 'vue';
import { Table, Rate, Empty } from 'ant-design-vue/es';
export default defineComponent({
  components: {
    Empty,
    'a-table': Table,
    'a-rate': Rate
  },
  setup() {
    const columns = [{
      title: '评价人',
      width: 260,
      dataIndex: 'driverName',
      key: 'driverName'
    }, {
      title: '评价对象',
      dataIndex: 'consignerName',
      width: 280,
      key: 'consignerName'
    }, {
      title: '评分',
      width: 260,
      dataIndex: 'consignerCode',
      key: 'consignerCode'
    }, {
      title: '评价内容',
      key: 'content',
      width: 260,
      dataIndex: 'content'
    }, {
      title: '评价单号',
      dataIndex: 'shipmentCode',
      key: 'shipmentCode',
      width: 200
    }, {
      title: '评价时间',
      dataIndex: 'createdTime',
      key: 'createdTime',
      width: 180
    }];
    function createTableData() {
      const list = [];
      //   // for (let index = 0; index < 100; index++) {
      //   //   const o = {
      //   //     key: index + '',
      //   //     name: 'John Brown ' + index,
      //   //     age: 5 + index,
      //   //     address: '',
      //   //     tags:
      //   //       index +
      //   //       '运费支付慢,装卸货地点不真实,克扣运费,卸货等待时间长,装货等待时间长时间长,装货等待时间长====',
      //   //   }
      //   //   list.push(o)
      //   // }
      return list;
    }
    const phoneFormat = val => {
      return `${val.substring(0, 3)}****${val.substring(7, 11)}`;
    };
    const nameFormat = val => {
      return `${val.substring(0, 1)}*${val.substring(2, 10)}`;
    };
    const data = createTableData();
    const state = reactive({
      columns,
      data
    });
    const list = [{
      driverName: '张鑫',
      driverPhone: '15249123377',
      consignerName: '榆林****世物流有限公司',
      loadScore: 5,
      payScore: 5,
      consignerSatisfiedScore: 5,
      platformSatisfiedScore: 5,
      shipmentCode: 'YD260309012312908948',
      createdTime: '2026-03-12 10:51:00'
    }];
    onMounted(() => {
      // checkShipmentCommentDriver().then((res) => {
      //   state.data = res
      // })
      state.data = list.map(item => {
        item.driverName = nameFormat(item.driverName);
        item.driverPhone = phoneFormat(item.driverPhone);
        return item;
      });
      console.log('state.data', state.data);
    });
    return {
      ...toRefs(state)
    };
  }
});